<template>
  <form-group
    title="Saldo atual"
  >
    <v-row justify="start">
      <v-col cols="6">
        <span>
          valor:
          <strong>
            <v-chip
              v-if="!loading"
              color="#E8F5E9"
              text-color="#66BB6A"
              class="text-uppercase"
              label
            >
              {{ balance }}
            </v-chip>
            <v-progress-circular
              v-else
              color="primary"
            />
          </strong>
        </span>
      </v-col>
    </v-row>
  </form-group>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import UserWalletRequest from '@/app/users/services/UserWalletRequest';
import currencyHelper from 'Arch/helpers/currencyHelper';

export default {
  name: 'UserWalletContent',
  components: { FormGroup },
  mixins: [ServiceMixin],
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
  },
  data: () => ({
    balance: 'teste',
    loading: false,
    requestClass: UserWalletRequest,
    config: {
      errorMessage: 'Falha ao buscar saldo do cliente!',
      showSuccessSwal: false,
    },
  }),
  computed: {
    clientId() {
      return this.value;
    },
  },
  watch: {
    clientId: {
      immediate: true,
      handler(id) {
        if (Number(id) > 0) {
          this.getBallance();
        }
      },
    },
  },
  methods: {
    getBallance() {
      this.handleLoading();
      this.makeRequest();
    },
    handleLoading() {
      this.loading = !this.loading;
    },
    makeRequest() {
      this.callService(
        this.requestClass.get(this.clientId),
        this.setBalance,
        this.config,
      );
    },
    setBalance(response) {
      this.handleLoading();
      if (this.hasData(response)) {
        this.balance = currencyHelper.format(response.data.data);
      }
    },
  },
};
</script>
